import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { AdminHeader } from "../../components/admin/AdminUI";
import { toast } from "sonner";

export default function ApplicationsAdmin() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/membership-applications").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const setStatus = async (id, status) => {
    await api.put(`/admin/membership-applications/${id}?status=${status}`);
    toast.success("Status updated"); load();
  };
  return (
    <div>
      <AdminHeader title="Membership Applications" subtitle={`${items.length} applications`} />
      <div className="space-y-3">
        {items.map((a) => (
          <div key={a.id} className="card-elev p-5">
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div>
                <div className="font-semibold text-brand-text">{a.full_name} <span className={`ml-2 text-[10px] px-2 py-0.5 rounded-full font-semibold uppercase ${a.status === "approved" ? "bg-brand-accent/10 text-brand-accent" : a.status === "rejected" ? "bg-red-100 text-red-600" : "bg-orange-100 text-orange-600"}`}>{a.status}</span></div>
                <div className="text-xs text-brand-muted mt-1">{a.email} • {a.phone} • {a.qualification}</div>
                <div className="text-xs text-brand-muted mt-1">{a.specialization} • {a.hospital || "—"} • {a.city || "—"}</div>
                {a.message && <p className="text-sm text-brand-text mt-2">{a.message}</p>}
              </div>
              <div className="flex items-center gap-2">
                <button onClick={() => setStatus(a.id, "approved")} className="text-xs px-3 py-1.5 rounded-lg bg-brand-accent/10 text-brand-accent font-semibold hover:bg-brand-accent hover:text-white transition-colors">Approve</button>
                <button onClick={() => setStatus(a.id, "rejected")} className="text-xs px-3 py-1.5 rounded-lg bg-red-50 text-red-600 font-semibold hover:bg-red-600 hover:text-white transition-colors">Reject</button>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="text-center text-brand-muted py-16">No applications yet.</div>}
      </div>
    </div>
  );
}
